module.exports = __webpack_public_path__ + "img/LC.408eaeaf.png";